class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);

/* ---------- Mixpanel Search Submitted Tracking ---------- */
(function () {
  var MIXPANEL_TOKEN = '225c2e83f7cb67a00728e0af7eacd4a6';

  function trackSearchSubmitted(rawQuery) {
    if (typeof rawQuery !== 'string') return;
    var trimmedQuery = rawQuery.trim();
    if (!trimmedQuery) return;

    var storageKey = 'slay_search_tracked_' + encodeURIComponent(trimmedQuery.toLowerCase());
    var lastTracked = sessionStorage.getItem(storageKey);
    var now = Date.now();
    if (lastTracked && (now - parseInt(lastTracked, 10)) < 5000) {
      return;
    }
    sessionStorage.setItem(storageKey, now.toString());

    try {
      if (typeof mixpanel !== 'undefined') {
        if (typeof mixpanel.has_opted_out_tracking === 'function' && mixpanel.has_opted_out_tracking()) {
          return;
        }
        if (
          typeof mixpanel.has_opted_in_tracking === 'function' &&
          mixpanel.config &&
          mixpanel.config.opt_out_tracking_by_default &&
          !mixpanel.has_opted_in_tracking()
        ) {
          return;
        }

        var props = {
          query: trimmedQuery,
          search_term: trimmedQuery
        };

        if (typeof mixpanel.track === 'function') {
          mixpanel.track('Search Submitted', props, { transport: 'sendBeacon' });
        } else if (navigator.sendBeacon) {
          var token = (mixpanel.config && mixpanel.config.token) || MIXPANEL_TOKEN;
          var distinctId = (mixpanel.get_distinct_id && mixpanel.get_distinct_id()) || window.MP_DISTINCT_ID;

          var payload = [{
            event: 'Search Submitted',
            properties: Object.assign({}, props, {
              token: token,
              distinct_id: distinctId,
              time: Math.floor(now / 1000),
              $transport: 'sendBeacon'
            })
          }];

          var blob = new Blob([JSON.stringify(payload)], { type: 'text/plain' });
          navigator.sendBeacon('https://api.mixpanel.com/track?ip=1', blob);
        }
      }
    } catch (e) {
      // Ignore analytics errors to keep search flow intact
    }
  }

  window.slayTrackSearchSubmitted = trackSearchSubmitted;

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !(form instanceof HTMLFormElement)) return;

      if (form.id === 'FacetFiltersForm' || form.id === 'FacetSortForm' || form.classList.contains('facets')) {
        return;
      }

      var isSearchForm =
        form.getAttribute('role') === 'search' ||
        form.classList.contains('search') ||
        form.classList.contains('search-modal__form') ||
        form.classList.contains('search-page-form') ||
        (form.action && form.action.indexOf('/search') !== -1);

      if (!isSearchForm) return;

      var input =
        form.querySelector('input[type="search"]') ||
        form.querySelector('input[name="q"]:not([type="hidden"])') ||
        form.querySelector('input[name="q"]');

      if (input && input.value) {
        if (form.querySelector('[aria-selected="true"] a')) {
          return;
        }
        trackSearchSubmitted(input.value);
      }
    },
    true
  );

  function checkSearchPageUrl() {
    if (window.location.pathname.indexOf('/search') !== -1) {
      var params = new URLSearchParams(window.location.search);
      var query = params.get('display_q') || params.get('q');
      if (query) {
        trackSearchSubmitted(query);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkSearchPageUrl);
  } else {
    checkSearchPageUrl();
  }
})();


